import { render, staticRenderFns } from "./QccSearchHistory.vue?vue&type=template&id=3d9ff460&scoped=true&"
import script from "./QccSearchHistory.vue?vue&type=script&lang=js&"
export * from "./QccSearchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ff460",
  null
  
)

component.options.__file = "QccSearchHistory.vue"
export default component.exports